/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import { useNitroStore } from "../../../store/Store";
import { env } from "../../../utils/env";

const Logo = ({ searchDisabled }: { searchDisabled: boolean }) => {
  const navigate = useNavigate();
  const [resetFilters] = useNitroStore((state) => [state.resetFilters]);

  return (
    <div
      className="appBarLogo"
      onClick={() => {
        resetFilters();
        navigate("/");
      }}
    >
      <svg
        className={`logo ${searchDisabled ? "disabled" : ""}`}
        viewBox="0 0 152 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.92099 14.9369C9.98994 29.8738 9.98994 29.8738 10.5502 32.0026C13.4869 43.1621 22.2031 50.6647 33.6796 51.9115C35.8764 52.1501 40.1804 51.876 40.9847 51.4459C41.5597 51.1387 41.4404 25.3512 40.8582 24.1089C39.5856 21.3927 38.3167 20.7773 33.9893 20.7773H30.6767L30.6229 30.6507C30.5631 41.6341 29.5225 42.4466 24.0301 35.7975C20.9035 32.0123 20.5851 30.5465 20.4832 19.4696L20.4008 10.5127L29.3689 10.5989C41.1005 10.7118 43.0155 11.2418 47.0953 15.5046C50.9737 19.5573 51.2766 21.003 51.2766 35.4692C51.2766 42.8983 51.3476 46.723 51.4855 46.723C52.0608 46.723 55.9144 42.7838 57.3089 40.7701C67.4031 26.1932 60.0604 5.90632 42.9186 1.01199C39.5365 0.0463096 38.6616 0 23.8208 0H9.85205L9.92099 14.9369Z"
          fill="#09B0F2"
        />
        <path
          d="M72.9009 46.3784V30.1431H76.3012L80.6247 39.7673H80.6698V30.1431H83.5071V46.3784H80.5347L75.7833 35.8997H75.7382V46.3784H72.9009Z"
          fill="#231F20"
        />
        <path
          d="M86.6671 46.3784V30.1431H89.7746V46.3784H86.6671Z"
          fill="#231F20"
        />
        <path
          d="M102.167 30.1431V32.8865H98.5416V46.3784H95.434V32.8865H91.8085V30.1431H102.167Z"
          fill="#231F20"
        />
        <path
          d="M107.121 37.2039H108.72C109.41 37.2039 109.951 37.0315 110.341 36.6867C110.732 36.3269 110.927 35.7498 110.927 34.9552C110.927 34.1607 110.732 33.5911 110.341 33.2463C109.951 32.8865 109.41 32.7066 108.72 32.7066H107.121V37.2039ZM111.31 46.3784L108.607 39.7673H107.121V46.3784H104.014V30.1431H108.517C110.394 30.1431 111.782 30.5704 112.683 31.4249C113.584 32.2644 114.034 33.4561 114.034 35.0002C114.034 36.0196 113.839 36.8816 113.449 37.5862C113.074 38.2907 112.45 38.8079 111.58 39.1377L114.642 46.3784H111.31Z"
          fill="#231F20"
        />
        <path
          d="M119.364 41.5663C119.364 42.4657 119.544 43.0729 119.904 43.3877C120.264 43.7025 120.76 43.8599 121.39 43.8599C122.021 43.8599 122.516 43.7025 122.877 43.3877C123.237 43.0729 123.417 42.4657 123.417 41.5663V34.9552C123.417 34.0558 123.237 33.4486 122.877 33.1338C122.516 32.819 122.021 32.6616 121.39 32.6616C120.76 32.6616 120.264 32.819 119.904 33.1338C119.544 33.4486 119.364 34.0558 119.364 34.9552V41.5663ZM116.256 35.36C116.256 34.3556 116.384 33.5086 116.639 32.819C116.894 32.1294 117.247 31.5748 117.697 31.155C118.148 30.7203 118.688 30.4055 119.319 30.2106C119.949 30.0157 120.64 29.9183 121.39 29.9183C122.141 29.9183 122.831 30.0157 123.462 30.2106C124.093 30.4055 124.633 30.7203 125.083 31.155C125.534 31.5748 125.886 32.1294 126.142 32.819C126.397 33.5086 126.525 34.3556 126.525 35.36V41.1615C126.525 42.1659 126.397 43.0129 126.142 43.7025C125.886 44.3921 125.534 44.9542 125.083 45.389C124.633 45.8087 124.093 46.116 123.462 46.3109C122.831 46.5058 122.141 46.6032 121.39 46.6032C120.64 46.6032 119.949 46.5058 119.319 46.3109C118.688 46.116 118.148 45.8087 117.697 45.389C117.247 44.9542 116.894 44.3921 116.639 43.7025C116.384 43.0129 116.256 42.1659 116.256 41.1615V35.36Z"
          fill="#231F20"
        />
      </svg>
      <Typography
        variant="h6"
        noWrap
        style={{ marginTop: 15, marginLeft: -7, color: "red", fontSize: 11 }}
      >
        {env.applicationName}
      </Typography>
    </div>
  );
};

export default Logo;
